import { render, staticRenderFns } from "./IntersectionSentinel.vue?vue&type=template&id=0fb0e0bb&"
import script from "./IntersectionSentinel.vue?vue&type=script&lang=ts&"
export * from "./IntersectionSentinel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports